/**
 * PaywallModal - Extracted from App.js Phase 4
 * Premium subscription upgrade gate
 */
import React from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PaywallModal = ({
  isOpen,
  onClose,
  userId,
  setCurrentView
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 10000 }} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px', padding: '0' }}>
        <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '24px', borderRadius: '12px 12px 0 0', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '8px' }}>star</div>
          <h2 style={{ margin: 0, color: 'white', fontSize: '22px' }}>Unlock SmartPlAIte Premium</h2>
          <p style={{ margin: '8px 0 0 0', color: 'rgba(255,255,255,0.85)', fontSize: '14px' }}>
            Nutritional intelligence -- reshaped by AI
          </p>
        </div>
        
        <div style={{ padding: '20px' }}>
          <div style={{ marginBottom: '20px' }}>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px', lineHeight: '2' }}>
              <li>AI Meal Plans + Recipes</li>
              <li>Barcode Scanning</li>
              <li>Micronutrients + RDA Tracking</li>
              <li>Trends + Goal Progress</li>
            </ul>
          </div>
          
          <button
            data-testid="paywall-start-trial-btn"
            onClick={async () => {
              try {
                const response = await fetch(`${BACKEND_URL}/api/billing/create-checkout-session`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ price_key: 'annual', origin_url: window.location.origin, user_id: userId })
                });
                if (response.ok) {
                  const data = await response.json();
                  window.location.href = data.session_url;
                } else {
                  const err = await response.json();
                  alert(err.detail || 'Could not start checkout');
                }
              } catch (e) { 
                console.error(e);
                alert('Error connecting to payment service');
              }
            }}
            style={{ width: '100%', padding: '14px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}
          >
            Start Premium Trial
          </button>
          <p style={{ textAlign: 'center', fontSize: '12px', color: 'var(--text-muted)', margin: '0 0 16px 0' }}>
            7 days free, then $39.99/year -- Cancel anytime
          </p>
          
          <button onClick={() => { onClose(); setCurrentView('subscription'); }}
            style={{ width: '100%', padding: '12px', background: 'rgba(255,255,255,0.1)', color: 'var(--text-primary)',
              border: '1px solid var(--border-subtle)', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', marginBottom: '10px' }}>
            View All Plans
          </button>
          
          <button onClick={onClose}
            style={{ width: '100%', padding: '10px', background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '13px' }}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaywallModal;
